/**
 * Shared icon configuration for map markers and filters
 * Maps entity types to their corresponding SVG icons
 */

export const MARKER_ICONS = {
  heart: {
    src: '/icons/explore/Explore-Hearts2-Map.svg',
    alt: 'Hearts',
    label: 'Hearts',
    detailsButtonText: 'Heart',
  },
  heartSaved: {
    src: '/icons/explore/Explore-Hearts-Saved-Map.svg',
    alt: 'Hearts',
    label: 'Hearts',
    detailsButtonText: 'Heart',
  },
  heartVisited: {
    src: '/icons/explore/Explore-Hearts-Visited-Map.svg',
    alt: 'Hearts',
    label: 'Hearts',
    detailsButtonText: 'Heart',
  },
  heartSavedVisited: {
    src: '/icons/explore/Explore-Hearts-Visited-Map.svg',
    alt: 'Hearts',
    label: 'Hearts',
    detailsButtonText: 'Heart',
  },
  community: {
    src: '/icons/explore/Explore-Communities2-Map.svg',
    alt: 'Communities',
    label: 'Communities',
    detailsButtonText: 'Community',
  },
  artist: {
    src: '/icons/explore/Explore-Artist2-Map.svg',
    alt: 'Artists',
    label: 'Artists',
    detailsButtonText: 'Artist',
  },
  attraction: {
    src: '/icons/explore/Explore-Attractions2-Map.svg',
    alt: 'Attractions',
    label: 'Attractions',
    detailsButtonText: 'Attraction',
  },
  event: {
    src: '/icons/explore/Explore-Events2-Map.svg',
    alt: 'Events',
    label: 'Events',
    detailsButtonText: 'Event',
  },
  promotion: {
    src: '/icons/explore/Explore-Promotions2-Map.svg',
    alt: 'Promotions',
    label: 'Promotions',
    detailsButtonText: 'Promotion',
  },
};

/**
 * Get icon configuration for a given type
 * @param {string} type - Entity type (heart, community, artist, attraction, event, promotion)
 * @returns {Object} Icon configuration with src, alt, and label
 */
export function getMarkerIcon(type) {
  return MARKER_ICONS[type] || MARKER_ICONS.heart; // Default to heart if type not found
}

/**
 * Get all available marker types
 * @returns {string[]} Array of marker type keys
 */
export function getMarkerTypes() {
  return Object.keys(MARKER_ICONS);
}

/**
 * Color mapping for type badges
 */
const TYPE_COLORS = {
  heart: 'text-[#D022BC]',
  attraction: 'text-[#288575]',
  event: 'text-[#176C85]',
  promotion: 'text-[#F6773D]',
  community: 'text-[#00EAFD]',
  artist: 'text-[#8B39C1]',
};

/**
 * Type badge component for entity type indicators
 * Uses shared marker icons for consistency with map view
 * @param {Object} props
 * @param {string} props.type - Entity type (heart, community, artist, attraction, event, promotion)
 */
export function TypeBadge({
  type,
  className = '',
  badgeClass = '',
  hideLabel = false,
  labelClassName = '',
}) {
  const icon = getMarkerIcon(type);
  const textColor = TYPE_COLORS[type] || 'text-gray-600';

  return (
    <span className={`flex items-start gap-1 !text-[#626262] ${textColor} ${className}`}>
      {!hideLabel && <span className={labelClassName}>{icon.label}</span>}
      <img src={icon.src} alt="" className={`w-4 h-4 ${badgeClass}`} aria-hidden="true" />
    </span>
  );
}
